<template>
    <transition name="dialog" @after-leave="afterLeave">
        <div v-show="isShow" style="z-index: 10000000; position: fixed; pointer-events: auto;">
            <div class="overlay" ref="overlay">
            </div>
            <div class="dialog" v-if="!loading">
                <div class="dialog__inner">
                    <h2 class="dialog__header" :style="{'background-color': headerColor, 'color': headerTextColor}">{{headerText}}</h2>
                    <div class="dialog__body" :style="{'text-align': messageTextAlign}">{{message}}</div>
                    <label for="askInput" v-if="nowAskDialog" style="display: none"></label>
                    <input v-model="askText" v-if="nowAskDialog" id="askInput" ref="askInput" :[askMlenTag]="askMax" :[askPholderTag]="askPlaceholder" style="width: 100%" autocomplete="off">
                    <div class="dialog__footer button-set" v-if="!nowChooseDialog">
                        <button
                                v-if="onSecondary"
                                type="button"
                                class="button button--base button--base-secondary"
                                @click.prevent="onSecondary">{{buttonList[1]}}</button>
                        <button
                                type="button"
                                class="button button--base button--base-primary"
                                @click.prevent="okClick">{{buttonList[0]}}</button>
                    </div>
                    <div class="dialog__footer button-set" v-else>
                        <template v-if="buttonList.length > 0">
                            <button
                                    v-for="(item,index) in buttonList"
                                    :key="index"
                                    type="button"
                                    class="button button--base button--base-secondary"
                                    @click.prevent="chooseClick(index)">{{item}}</button>
                        </template>
                        <button
                                :key="buttonListLastIndex"
                                type="button"
                                class="button button--base button--base-primary"
                                @click.prevent="chooseClick(buttonListLastIndex)">{{buttonListLast}}</button>
                    </div>
                </div>
            </div>
            <div class="dialog" v-else>
                <div v-if="loadingMessage" class="loadingMsg">
                    <div class="loadingMsgMsg" :style="{ color: progMsgColor, backgroundColor: progMsgBackColor,}">{{loadingMessage}}</div>
                </div>
                <div v-if="loadingProgress !== null" class="loadingMsgProg">
                    <svg :width="loadingProgressWidth + 'px'" height="12px" viewBox="0 0 200 12" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <defs></defs>
                        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="ProgressBar">
                                <g id="Group">
                                    <rect id="Rectangle-5" :fill="progBarBackColor" x="0" y="0" width="200" height="12"></rect>
                                    <rect id="Rectangle-5" :fill="progBarColor" x="0" y="0" :width="loadingProgress * 200" height="12"></rect>
                                </g>
                            </g>
                        </g>
                    </svg>
                </div>
                <div :class="loadingClass" :style="loadingStyles" v-if="loadingSVG === null">Loading...</div>
                <div v-if="loadingSVG === 'circle'">
                    <svg width="110px" height="110px" viewBox="0 0 160 160" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <defs>
                            <linearGradient x1="102.855521%" y1="95.1146455%" x2="50%" y2="83.9655588%" id="linearGradient-1">
                                <stop :stop-color="loadingFG" stop-opacity="0" offset="0%"></stop>
                                <stop :stop-color="loadingFG" offset="100%"></stop>
                            </linearGradient>
                        </defs>
                        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <path d="M80,160 C35.81722,160 0,124.18278 0,80 C0,35.81722 35.81722,0 80,0 C124.18278,0 160,35.81722 160,80 C160,124.18278 124.18278,160 80,160 Z M80,136 C110.927946,136 136,110.927946 136,80 C136,49.072054 110.927946,24 80,24 C49.072054,24 24,49.072054 24,80 C24,110.927946 49.072054,136 80,136 Z" id="Combined-Shape2" :fill-opacity="loadingFO" :fill="loadingFG"></path>
                            <g id="LoadingCircle" fill="url(#linearGradient-1)">
                                <path d="M80,24 L80,0 C35.81722,3.53647956e-14 0,35.81722 0,80 C0,124.18278 35.81722,160 80,160 L80,136 C49.072054,136 24,110.927946 24,80 C24,49.072054 49.072054,24 80,24 Z" id="Combined-Shape">
                                    <animateTransform attributeType="xml"
                                                      attributeName="transform"
                                                      type="rotate"
                                                      from="0 80 80"
                                                      to="360 80 80"
                                                      dur="1s"
                                                      repeatCount="indefinite"/>
                                </path>
                            </g>
                        </g>
                    </svg>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
  let debugOut = false
  export default {
    props: {
      subject: String,
      message: String,
      onPrimary: Function,
      onSecondary: {
        type: Function,
        default: null
      },
      messageAlign: {
        type: String,
        default: 'center'
      },
      dialogType: {
        type:String,
        default: 'confirm',
      },
      askMaxLength: {
        type: Number,
        default: null,
      },
      askPlaceholder: {
        type: String,
        default: null,
      },
      askDefText: {
        type: String,
        default: null,
      },
      nameList: {
        type: Array,
        default: null,
      },
      loadingFG: {
        type: String,
        default: '#ffffff'
      },
      // loadingAddColors: {
      //   type: Object,
      //   default: () => ({progMsgColor: '#000000', progMsgBackColor: 'rgba(255, 255, 255, 0.3)', progBarColor: '#84BBFF', progBarBackColor: '#EEEEEE',}),
      // },
      progMsgColor: {
        type: String,
        default:'#000000',
      },
      progMsgBackColor: {
        type: String,
        default:'rgba(255, 255, 255, 0.3)',
      },
      progBarColor: {
        type: String,
        default:'#84BBFF',
      },
      progBarBackColor: {
        type: String,
        default:'#EEEEEE',
      },
    },
    data () {
      return {
        isShow: false,
        askText: "",
        loading: false,
        loadingClass: "loading0",
        loadingSVG: null,
        loadingFO: 0,
        loadingMessage: "",
        loadingProgress: null,
        documentAreaWidth: 0,
      }
    },
    created() {
    },
    mounted() {
      if (debugOut) {console.log(`Dialog.vue component mounted ('${this.dialogType}' mode)`)}
      if (this.dialogType.startsWith('loading')) {
        let tmpFlag = false
        this.loading = true
        this.loadingClass = this.dialogType
        switch (this.dialogType) {
          case 'loading2':
            tmpFlag = true
            // eslint-disable-next-line no-fallthrough
          case 'loading3':
            this.loadingSVG = 'circle'
            this.loadingFO = tmpFlag ? 0 : 0.2
            break
          default:
            this.loadingSVG = null
        }
      } else {
        if (this.askDefText) {
          this.askText = this.askDefText
        }
        this.$nextTick(function () {
          if (this.dialogType === 'ask') {
            this.$refs.askInput.focus()
          }
        })
      }
    },
    computed: {
      messageTextAlign() {
        return this.messageAlign
      },
      headerColor() {
        switch (this.dialogType) {
          case 'confirm':
            return '#adf5b3'
          case 'error':
            return '#f55844'
          case 'warn':
            return '#ffeb00'
          case 'alert':
            return '#fff713'
          case 'info':
            return '#20b85f'
          case 'ask':
            return '#2c8cff'
          case 'choose':
            return '#906500'
          default:
            return '#fff'
        }
      },
      loadingStyles() {
        return { '--fgcolor': this.loadingFG }
      },
      headerTextColor() {
        switch (this.dialogType) {
          case 'confirm':
            return '#fff'
          case 'error':
            return '#fff'
          case 'warn':
            return '#000'
          case 'alert':
            return '#000'
          case 'info':
            return '#000'
          case 'ask':
            return '#fff'
          case 'choose':
            return '#fff'
          default:
            return  (this.headerColor === '#fff') ? '#000' : '#fff'
        }
      },
      headerText() {
        return (this.subject && (this.subject !=="" )) ? this.subject : this.defaultTypeTitle
      },
      defaultTypeTitle() {
        switch (this.dialogType) {
          case 'confirm':
            return '確認'
          case 'error':
            return 'エラー'
          case 'warn':
            return '警告'
          case 'alert':
            return '警告'
          case 'info':
            return '情報'
          case 'ask':
            return '質問'
          case 'choose':
            return '選択'
          default:
            return '確認'
        }
      },
      nowAskDialog() {
        return this.dialogType === 'ask'
      },
      nowChooseDialog() {
        return this.dialogType === 'choose'
      },
      askMax() {
        return this.askMaxLength || 0
      },
      askMlenTag() {
        return this.askMaxLength ? "maxLength" : null
      },
      askPholderTag() {
        return this.askPlaceholder ? "placeholder" : null
      },
      buttonList() {
        if (this.nowChooseDialog) {
          return (!this.nameList || this.nameList.length === 0) ? [] : this.nameList.slice(0,-1)
        } else {
          return this.nameList || ["OK","キャンセル"]
        }
      },
      buttonListLast() {
        return (!this.nameList || this.nameList.length === 0) ? 'キャンセル' : this.nameList[this.nameList.length - 1]
      },
      buttonListLastIndex() {
        return this.buttonList.length
      },
      loadingProgressWidth() {
        return this.documentAreaWidth * 0.75
      },
    },
    watch: {
      'isShow' (to) {
        if (to) {
          this.$nextTick(() => {
            this.documentAreaWidth = this.$refs.overlay.clientWidth
          })
        }
      }
    },
    methods: {
      clickBG() {
        if (debugOut) {console.log('click BG')}
      },
      okClick() {
        if (this.nowAskDialog) {
          this.onPrimary(this.askText)
        } else {
          this.onPrimary()
        }
      },
      chooseClick(idx) {
        this.onPrimary(idx)
      },
      keydownEvent(e) {
        if (debugOut) {console.log(`key down ('${e.key}')`)}
        if (e.key === 'Enter') {
          return false
        }
      },
      attach () {
        if (debugOut) {console.log('Dialog.vue component attach()')}
        if (!this.$parent) {
          this.$mount()
          document.body.appendChild(this.$el)
        } else {
          this.$mount()
          this.$parent.$el.appendChild(this.$el)
        }
      },
      remove () {
        if (debugOut) {console.log('Dialog.vue component remove()')}
        if (!this.$parent) {
          document.body.removeChild(this.$el)
          this.$destroy()
        } else {
          this.$parent.$el.removeChild(this.$el)
          this.$destroy()
        }
      },
      close () {
        if (debugOut) {console.log('Dialog.vue component close()')}
        document.onkeydown = this.keydownHandler
        if (debugOut) {console.log('Dialog.vue component afterLeave()')}
        this.isShow = false
      },
      show () {
        if (debugOut) {console.log('Dialog.vue component show()')}
        this.keydownHandler = document.onkeydown
        document.onkeydown = this.keydownEvent
        this.attach()
        this.isShow = true
      },
      afterLeave () {
        this.remove()
      },
      loadingMessageSet(message) {
        this.loadingMessage = message
      },
      loadingProgressSet(prog) {
        this.loadingProgress = prog
      }
    }
  }
</script>

<style scoped lang="scss">
    .overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0,0,0,0.5);
        opacity: 0.5;
        //z-index: -120;
    }

    .dialog {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .dialog button {
        pointer-events: auto;
    }

    .dialog__inner {
        position: fixed;
        //z-index: -111;
        width: 70vw;
        padding: 20px 20px 10px 20px;
        background-color: #fff;

        margin: 2em 0;
        border-radius: 9px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.22);
    }
    .dialog__header {
        position: absolute;
        display: inline-block;
        top: -15px;
        left: 0;
        right: 0;
        font-size: 1em;
        border-radius: 9px 9px 0 0;
        padding: 2px;
        text-align: center;
        font-weight: bold;
        letter-spacing: 0.05em;
    }
    .dialog__body {
        padding: 15px 20px;
        margin: 0;
        white-space: pre-line;
    }
    .button-set {
        display: flex;
    }
    .button--base {
        flex: 1;
        margin: 10px 10px 0;
        border: 1px solid #808080;
        border-radius: 8px;
    }
    .button--base-primary {
        border-width: 1px;
    }

    .dialog-enter-active, .dialog-leave-active {
        transition: opacity .3s;
    }
    .dialog-leave, .dialog-enter-to {
        filter:alpha(opacity=100);
        opacity: 1;
    }
    .dialog-enter, .dialog-leave-to {
        filter:alpha(opacity=0);
        opacity: .0;
    }

    .common {
        --fgcolor: #ffffff;
    }

    .loading0 {
        color: var(--fgcolor);
        font-size: 20px;
        margin: 100px auto;
        width: 1em;
        height: 1em;
        border-radius: 50%;
        position: relative;
        text-indent: -9999em;
        animation: load4 1.3s infinite linear;
        transform: translateZ(0);
    }
    @-webkit-keyframes load4 {
        0%,
        100% {box-shadow: 0 -3em 0 0.2em, 2em -2em 0 0em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 0;}
        12.5% {box-shadow: 0 -3em 0 0, 2em -2em 0 0.2em, 3em 0 0 0, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;}
        25% {box-shadow: 0 -3em 0 -0.5em, 2em -2em 0 0, 3em 0 0 0.2em, 2em 2em 0 0, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;}
        37.5% {box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 0, 2em 2em 0 0.2em, 0 3em 0 0em, -2em 2em 0 -1em, -3em 0em 0 -1em, -2em -2em 0 -1em;}
        50% {box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 0em, 0 3em 0 0.2em, -2em 2em 0 0, -3em 0em 0 -1em, -2em -2em 0 -1em;}
        62.5% {box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 0, -2em 2em 0 0.2em, -3em 0 0 0, -2em -2em 0 -1em;}
        75% {box-shadow: 0em -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0.2em, -2em -2em 0 0;}
        87.5% {box-shadow: 0em -3em 0 0, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0, -2em -2em 0 0.2em;}
    }
    @keyframes load4 {
        0%,
        100% {box-shadow: 0 -3em 0 0.2em, 2em -2em 0 0em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 0;}
        12.5% {box-shadow: 0 -3em 0 0, 2em -2em 0 0.2em, 3em 0 0 0, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;}
        25% {box-shadow: 0 -3em 0 -0.5em, 2em -2em 0 0, 3em 0 0 0.2em, 2em 2em 0 0, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;}
        37.5% {box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 0, 2em 2em 0 0.2em, 0 3em 0 0em, -2em 2em 0 -1em, -3em 0em 0 -1em, -2em -2em 0 -1em;}
        50% {box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 0em, 0 3em 0 0.2em, -2em 2em 0 0, -3em 0em 0 -1em, -2em -2em 0 -1em;}
        62.5% {box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 0, -2em 2em 0 0.2em, -3em 0 0 0, -2em -2em 0 -1em;}
        75% {box-shadow: 0em -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0.2em, -2em -2em 0 0;}
        87.5% {box-shadow: 0em -3em 0 0, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0, -2em -2em 0 0.2em;}
    }

    .loading1 {
        color: var(--fgcolor);
        font-size: 90px;
        text-indent: -9999em;
        overflow: hidden;
        width: 1em;
        height: 1em;
        border-radius: 50%;
        margin: 72px auto;
        position: relative;
        transform: translateZ(0);
        animation: load6 1.7s infinite ease, round 1.7s infinite ease;
    }
    @-webkit-keyframes load6 {
        0% {box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;}
        5%,
        95% {box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;}
        10%,
        59% {box-shadow: 0 -0.83em 0 -0.4em, -0.087em -0.825em 0 -0.42em, -0.173em -0.812em 0 -0.44em, -0.256em -0.789em 0 -0.46em, -0.297em -0.775em 0 -0.477em;}
        20% {box-shadow: 0 -0.83em 0 -0.4em, -0.338em -0.758em 0 -0.42em, -0.555em -0.617em 0 -0.44em, -0.671em -0.488em 0 -0.46em, -0.749em -0.34em 0 -0.477em;}
        38% {box-shadow: 0 -0.83em 0 -0.4em, -0.377em -0.74em 0 -0.42em, -0.645em -0.522em 0 -0.44em, -0.775em -0.297em 0 -0.46em, -0.82em -0.09em 0 -0.477em;}
        100% {box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;}
    }
    @keyframes load6 {
        0% {box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;}
        5%,
        95% {box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;}
        10%,
        59% {box-shadow: 0 -0.83em 0 -0.4em, -0.087em -0.825em 0 -0.42em, -0.173em -0.812em 0 -0.44em, -0.256em -0.789em 0 -0.46em, -0.297em -0.775em 0 -0.477em;}
        20% {box-shadow: 0 -0.83em 0 -0.4em, -0.338em -0.758em 0 -0.42em, -0.555em -0.617em 0 -0.44em, -0.671em -0.488em 0 -0.46em, -0.749em -0.34em 0 -0.477em;}
        38% {box-shadow: 0 -0.83em 0 -0.4em, -0.377em -0.74em 0 -0.42em, -0.645em -0.522em 0 -0.44em, -0.775em -0.297em 0 -0.46em, -0.82em -0.09em 0 -0.477em;}
        100% {box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;}
    }
    @-webkit-keyframes round {
        0% {transform: rotate(0deg);}
        100% {transform: rotate(360deg);}
    }
    @keyframes round {
        0% {transform: rotate(0deg);}
        100% {transform: rotate(360deg);}
    }

    .loading4,
    .loading4:before,
    .loading4:after {
        background: var(--fgcolor);
        animation: load1 1s infinite ease-in-out;
        width: 1em;
        height: 4em;
    }
    .loading4 {
        color: var(--fgcolor);
        text-indent: -9999em;
        margin: 88px auto;
        position: relative;
        font-size: 11px;
        transform: translateZ(0);
        animation-delay: -0.16s;
    }
    .loading4:before,
    .loading4:after {
        position: absolute;
        top: 0;
        content: '';
    }
    .loading4:before {
        left: -1.5em;
        animation-delay: -0.32s;
    }
    .loading4:after {
        left: 1.5em;
    }
    @-webkit-keyframes load1 {
        0%,
        80%,
        100% {
            box-shadow: 0 0;
            height: 4em;
        }
        40% {
            box-shadow: 0 -2em;
            height: 5em;
        }
    }
    @keyframes load1 {
        0%,
        80%,
        100% {
            box-shadow: 0 0;
            height: 4em;
        }
        40% {
            box-shadow: 0 -2em;
            height: 5em;
        }
    }

    .loadingMsg {
        display: flex;
        position: fixed;
        flex-flow: column;
        font-weight: bold;
        /*justify-content: center;*/
        /*text-align: center;*/
        left: 50%;
        top: calc(50% + 96px);
        transform: translateX(-50%);
    }

    .loadingMsgMsg {
        width: fit-content;
        height: 1.5rem;
        padding: 0 1rem 0 1rem;
        border-radius: 0.6rem;
    }

    .loadingMsgProg {
        position: fixed;
        left: 50%;
        transform: translateX(-50%);
        top: calc(50% + 96px + 2rem);
    }

</style>